module.exports = __webpack_public_path__ + "static/img/logo.073029f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 200
// module chunks = 1